import EyeIconSVG from "assets/svg/eye-icon";
import Button from "components/button/button";
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import _ from "lodash";
import TemplateFiveFullPageOne from "../full-preview/template-five/page-one";
import TemplateFiveFullPageTwo from "../full-preview/template-five/page-two";

/** TEAM/GROUP TEMPLATES */
import TemplateOneTG from "./template-one-tg";
import TemplateTwoPageOneTG from "./template-two-tg/page-one";
import TemplateFourPageOneTG from "./template-four-tg/page-one";
import { useHistory } from "react-router-dom";
import { TEMPLATE_NAME_1, TEMPLATE_NAME_2, TEMPLATE_NAME_3, TEMPLATE_NAME_4, TEMPLATE_NAME_5} from "constants/options";
import { useTranslation } from "react-i18next";
import html2canvas from 'html2canvas';
import { dataURLtoFile } from "utils/utils";
import { forwardRef, useImperativeHandle } from "react";
import { sortMilestones } from "utils/utils";
import { groupArraysWithType, LONG_SIZE } from "../resume";
import { applySharedBudget } from "utils/bio-limit";
import TemplateOneFull from "../full-preview/template-one";
import TemplateTwoFullPageOne from "../full-preview/template-two/page-one";
import TemplateTwoFullPageTwo from "../full-preview/template-two/page-two";
import TemplateFourFullPageOne from "../full-preview/template-four/page-one";
import TemplateFourFullPageTwo from "../full-preview/template-four/page-two";
import { useResume } from "redux/modules/resume/hooks";

const PreviewPDF = forwardRef (({
  state = {},
  previewImage,
  milestones = {},
  primaryColor,
  secondaryColor,
  tertiaryColor,
  quarternary,
  page,
  setPage,
  setSelectedTab = () => {},
  profile,
},ref) => {
  const {t} = useTranslation()
  const history = useHistory();
  const [totalPage, setTotalPage] = React.useState(2);
  const [mergeMilestone, setMergeMilestone] = React.useState([]);
  const cardRef = React.useRef();
  const { resumes } = useResume();
  // Mirror the live preview's merge so the downloaded PDF matches what the user
  // sees: base on the current edit buffer, let saved values win only where set.
  // (Marker.io MCF-1767)
  const moreInfo = React.useMemo(() => {
    const found = resumes?.find((item) => item.id === state.id);
    const merged = { ...(state?.more || {}) };
    const saved = found?.more_info || {};
    Object.keys(saved).forEach((k) => {
      const v = saved[k];
      if (v !== null && v !== undefined && v !== "") merged[k] = v;
    });
    // Cut pooled text boxes to the template's shared budget (MCF-637).
    return applySharedBudget(merged, state.templateName);
  }, [resumes, state.id, state?.more, state.templateName]);


  
  React.useEffect(() => { 
    if(state.templateName === TEMPLATE_NAME_5) return;
    const arraysWithType = [
      { array: sortMilestones(milestones?.featured) || [], type: 'featured' },
      { array: sortMilestones(milestones?.current) || [], type: 'current' },
      { array: sortMilestones(milestones?.past) || [], type: 'past' },
    ];
    if(state.templateName !== TEMPLATE_NAME_5){
      let groupAll;
      switch(state.templateName){
        case TEMPLATE_NAME_1:
          groupAll = groupArraysWithType(arraysWithType,6,6);
          break;
        case TEMPLATE_NAME_2:
          groupAll = groupArraysWithType(arraysWithType,6,6);
          break;
        case TEMPLATE_NAME_3:
          groupAll = groupArraysWithType(arraysWithType,7,7);
          break;
        case TEMPLATE_NAME_4:
          groupAll = groupArraysWithType(arraysWithType,8,8);
          break;
        default:
          groupAll = groupArraysWithType(arraysWithType,6,6);
      }
      console.log("Check Merge")
      console.log(groupAll)
      setMergeMilestone(groupAll)
      if(groupAll.length === 0){
        setTotalPage(2)
      }else{
        setTotalPage(groupAll.length + 1) // plus 1 for the fist page this is only for the individual;
      }
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestones?.featured,milestones?.current, milestones?.past, state.templateName]);


  const handleCapture = async () => {
    if(cardRef.current){
      const canvas = await html2canvas(cardRef.current, {useCORS: true, allowTaint: true });
      const dataURL = canvas.toDataURL("image/png");
      const file_data = dataURLtoFile(dataURL, `screenshot-${state?.id}.png`);
      //  return file_data;
     
      return file_data
    }
  };

  useImperativeHandle(ref, () => ({
    handleCapture,
  }));

  return (
    <div className={`w-full flex justify-start `}>
      {/* header buttons */}
      <div className="w-full max-w-screen-9sm grid gap-y-6 pl-2 ">
        <div style={{
            width: 816 * 0.80,
            height: 1223 * 0.80,
          }}>
        <div className="relative" style={{...LONG_SIZE, transformOrigin: "top left", transform: "scale(0.80)"}}>
          {/* body */}
          {state.templateName === TEMPLATE_NAME_1 && (
             <div id={TEMPLATE_NAME_1}>
              <div ref={cardRef}>
                <TemplateOneFull
                  {...{
                    page:1,
                    previewImage,
                    milestones,
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    profile,
                    totalPage
                  }}
                  details={moreInfo}
                  personal={state.personal}
                  social={state.social}
                  show_image_milestone = {state.show_milestone_image}
                  show_qr_milestone = {state.show_qr_milestone}
                  show_qr_reels = {state.show_qr_reels}
                  hideOccupation={state.hideOccupation}
                  milestone_position = {state.milestone_position}
                  setTotalPage={setTotalPage}
                
                />
              </div>
              {
                mergeMilestone.map((item,index)=>{
                    return (
                      <div className="mb-4" key={index}>
                          <TemplateOneFull
                            {...{
                              item:item,
                              page: index+2,
                              previewImage,
                              milestones,
                              primaryColor,
                              secondaryColor,
                              tertiaryColor,
                              profile,
                              mergeMilestone,
                              totalPage,
                              show_qr_milestone:state.show_qr_milestone,
                              show_qr_reels:state.show_qr_reels
                            }}
                            details={moreInfo}
                            personal={state.personal}
                            social={state.social}
                            totalPage={totalPage}
                            milestone_position = {state.milestone_position}
                            
                    />
                      </div>
                    )
                  }) 
              }
              </div>
                
          )}
          {state.templateName === TEMPLATE_NAME_2 && (
            <div id={TEMPLATE_NAME_2}>
              <div ref={cardRef}>
                <TemplateTwoFullPageOne
                  {...{
                    page,
                    previewImage,
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    quarternary,
                    profile,
                    milestones,
                    totalPage
                  }}
                  color={state.color}
                  active={page === 1}
                  details={moreInfo}
                  personal={state.personal}
                  social={state.social}
                  show_image_milestone = {state.show_milestone_image}
                  setTotalPage={setTotalPage}
                  hideOccupation={state.hideOccupation}
                  milestone_position = {state.milestone_position}
                />
              </div>
                {
                  (mergeMilestone.map((item,index)=>{
                    return (
                      <div key={index}>
                        {
                          <TemplateTwoFullPageTwo
                          {...{
                            item:item,
                            page: index+2,
                            previewImage,
                            milestones,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                            profile,
                            totalPage,
                            show_qr_milestone:state.show_qr_milestone,
                            show_qr_reels:state.show_qr_reels
                          }}
                          color={state.color}
                          social={state.social}
                          milestone_position = {state.milestone_position}
                          show_image_milestone = {state.show_milestone_image}
                        />
                        }
                        
                      </div>
                    )
                  }))
                }
            </div>
          )}
          {state.templateName === TEMPLATE_NAME_4 && (
             <div id={TEMPLATE_NAME_4}>
                <TemplateFourFullPageOne
                  {...{
                    page,
                    totalPage,
                    previewImage,
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    quarternary,
                    profile,
                    milestones
                  }}
                  color={state.color}
                  active={page === 1}
                  details={moreInfo}
                  personal={state.personal}
                  social={state.social}
                  setTotalPage={setTotalPage}
                  hideOccupation={state.hideOccupation}
                  milestone_position = {state.milestone_position}
                />
              {
                (
                  mergeMilestone.map((item,index)=>{
                  return (
                    <div key={index}>
                      <TemplateFourFullPageTwo
                        {...{
                          item:item,
                          page: index+2,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          totalPage
                        }}
                        color={state.color}
                        active={page === 2}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        setTotalPage={setTotalPage}
                        show_qr_milestone = {state.show_qr_milestone}
                        show_qr_reels = {state.show_qr_reels}
                        milestone_position = {state.milestone_position}
                      />
                    </div>
                  )
                })
              )
              }
            </div>
          )}
          {state.templateName === TEMPLATE_NAME_5 && (
           <div id={TEMPLATE_NAME_5}>
              <TemplateFiveFullPageOne
              {...{
                page,
                totalPage,
                previewImage,
                primaryColor,
                secondaryColor,
                tertiaryColor,
                quarternary,
                profile,
                milestones
              }}
              color={state.color}
              active={page === 1}
              details={moreInfo}
              personal={state.personal}
              social={state.social}
              setTotalPage={setTotalPage}
              hideOccupation={state.hideOccupation}
              milestone_position = {state.milestone_position}
              fullPreview={true}
              minHeight="305mm"
            />
            <TemplateFiveFullPageTwo
            {...{
              page:2,
              totalPage,
              previewImage,
              milestones,
              primaryColor,
              secondaryColor,
              tertiaryColor,
              quarternary,
            }}
            color={state.color}
            active={page === 2}
            details={moreInfo}
            personal={state.personal}
            social={state.social}
            show_image_milestone = {state.show_milestone_image}
            setTotalPage={setTotalPage}
            show_qr_milestone = {state.show_qr_milestone}
            show_qr_reels = {state.show_qr_reels}
            milestone_position = {state.milestone_position}
            fullPreview={true}
          />
          </div>
          )}
        </div>
        </div>
        
      </div>
    </div>
  );
});

export default PreviewPDF;
